import Button from '@/common/components/Button'
import { EstablishmentRequiredDocumentData } from '@/common/types/establishmentRequiredDocument'
import { formatDecimal } from '@/common/utils/formatters'
import { ArrowBigRight } from 'lucide-react'
import { Link } from 'react-router-dom'

export class EstablishmentRequiredDocumentsTransformer {
  static tableTransformer() {
    return (establishmentRequiredDocuments: EstablishmentRequiredDocumentData[]) => {
      return establishmentRequiredDocuments.map((establishmentRequiredDocument) => {
        return {
          ...establishmentRequiredDocument,
          default_validity_in_days: establishmentRequiredDocument.default_validity_in_days
            ? `${formatDecimal(establishmentRequiredDocument.default_validity_in_days, 0)} Dia${
                establishmentRequiredDocument.default_validity_in_days > 1 ? 's' : ''
              }`
            : '',
          action: (
            <Link to={`/establishment-required-documents/${establishmentRequiredDocument.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Admin::Maintenance::EstablishmentRequiredDocuments::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
